import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-header-navigazione-multipla',
  templateUrl: './header-navigazione-multipla.component.html',
  styleUrls: ['./header-navigazione-multipla.component.css','../mediaquerie.css']
})
export class HeaderNavigazioneMultiplaComponent implements OnInit {
  @Input() cy: any;
  @Output() clickedFiltroMultiplo = new EventEmitter<boolean>();
  @Output() paginaRefresh = new EventEmitter<boolean>();
  @Output() creaElemento = new EventEmitter<boolean>();
  clicked:boolean;
  zoomStep: number = 0.1;
  zoomCurrent: number = 1;
  @Input() createElement:boolean = false;

  // slider btn
  @Input() disabilitaSliderBtn: boolean= true ;
  @Input() isCheck = false;
  @Output() recuperaLeInferenze = new EventEmitter<boolean>();
  
  // slider btn concetti
  @Input() conceptIncludesIsCheck = false;
  @Output() recuperaConcetti = new EventEmitter<boolean>();
  // invio evento per click btn cammino minimo
  @Output() btnMinPathClicked = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit(): void {
  }

  refreshPagina(): void {
    this.clicked = false;
    this.cy.remove(this.cy.elements(':visible'));
    this.cy.reset();
    this.clickedFiltroMultiplo.emit(this.clicked);
    sessionStorage.removeItem('nodiSelezionati');
    this.createElement = false;
    this.creaElemento.emit(this.createElement);
    this.paginaRefresh.emit(true);
    this.isCheck = false;
    this.conceptIncludesIsCheck = false;
    this.disabilitaSliderBtn = true;
    sessionStorage.setItem('disableSliderInf','true');
    sessionStorage.setItem('sliderChecked','false'); 
    sessionStorage.setItem('sliderConceptIncludesIsCheck','false'); 
  }

  centrare(): void {
    var elementiVisibili = this.cy.elements(':visible');
    this.cy.center(elementiVisibili);
  }

  zoomIn(): void {
    if (this.zoomCurrent < this.cy.maxZoom()) {
      this.zoomCurrent += this.zoomStep;
      this.cy.zoom({
        level: this.zoomCurrent,
        position: { x: this.cy.getElementById(sessionStorage.getItem('viewMultipla')).position('x'), y: this.cy.getElementById(sessionStorage.getItem('viewMultipla')).position('y') }
      });
    }
  }

  zoomOut(): void {
    if (this.zoomCurrent > this.cy.minZoom()) {
      this.zoomCurrent -= this.zoomStep;
      this.cy.zoom({
        level: this.zoomCurrent,
        position: { x: this.cy.getElementById(sessionStorage.getItem('viewMultipla')).position('x'), y: this.cy.getElementById(sessionStorage.getItem('viewMultipla')).position('y') }
      });
    }
  }

  creaElement(): void {
    if(this.createElement === false){
      this.createElement = true;
      this.creaElemento.emit(this.createElement);
    } else {
      this.createElement = false;
      this.creaElemento.emit(this.createElement);
    }
  }

  calcolaMinPath(): void{
    this.disabilitaSliderBtn = false;
    sessionStorage.setItem('disableSliderInf','false')  
    this.recuperaInferenze();
    this.includiConcetti();
    }

  recuperaInferenze(){  
    // se true recupera inferenze altrimenti no
    if(this.isCheck === true){
      sessionStorage.setItem('sliderChecked','true')  
      this.recuperaLeInferenze.emit(true)
    } else {
      sessionStorage.setItem('sliderChecked','false')  
      this.recuperaLeInferenze.emit(false)
    }
  }

  includiConcetti() {
    if(this.conceptIncludesIsCheck === true){
      sessionStorage.setItem('sliderConceptIncludesIsCheck','true')  
      this.recuperaConcetti.emit(true)
    } else {
      sessionStorage.setItem('sliderConceptIncludesIsCheck','false')  
      this.recuperaConcetti.emit(false)
    }
  }
}
